import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/rei-docusign-logos.png'


const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $setup.props.isOpen,
    onClose: $setup.close,
    classes: 'without-padding select-option-to-generate-contract'
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "modal-header" }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          class: "docusign-rei-img",
          src: _imports_0,
          alt: "docusign-logo"
        }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-body" }, [
          _createElementVNode("div", { class: "description" }, [
            _createElementVNode("h2", null, "Select the platform you would like to use to generate a contract.")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "button primary soon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
          }, [...(_cache[1] || (_cache[1] = [
            _createTextVNode("REI Forms LIVE", -1)
          ]))])), [
            [_directive_tippy, { content: 'Coming soon', theme: 'light-border', placement: 'top' }]
          ]),
          _createElementVNode("button", {
            class: "button primary",
            onClick: $setup.generate
          }, "DocuSign")
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}